import React from 'react';
import * as S from './styles';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import { QuoteItemCommentHeaderResponse } from '@/main/models/response';
import { isNullUndefined } from '@/main/services/utils';
import ResultNotFoundComponent from '@/main/components/shared/resultNotFound/resultNotFoundComponent';

interface IHeaderModaCommentProps {
  dataHeader: QuoteItemCommentHeaderResponse | null;
  isLoadingHeader: boolean;
}

function HeaderModaComment({
  dataHeader,
  isLoadingHeader
}: IHeaderModaCommentProps) {
  if (isLoadingHeader) return <LoadingComponent />;
  if (isNullUndefined(dataHeader)) return <ResultNotFoundComponent />;

  function formatDataHeader() {
    if (isNullUndefined(dataHeader)) return '';

    const { supplierName, quoteProcurementPartInfo } = dataHeader;

    const partName =
      quoteProcurementPartInfo.partName ??
      quoteProcurementPartInfo.quoteItemDescription;
    const partType = quoteProcurementPartInfo.partType;

    const texts = [partName, partType].filter(Boolean).join(' - ');

    return (
      <>
        {supplierName && <strong>{supplierName}</strong>}
        {supplierName && texts ? (
          <span style={{ margin: '0 2px 0 4px' }}> - </span>
        ) : (
          ''
        )}

        {partName && <strong>{partName}</strong>}
        {partName && partType && <span> - </span>}
        {partType}
      </>
    );
  }

  return (
    <S.Container>
      <S.AreaText>{formatDataHeader()}</S.AreaText>
    </S.Container>
  );
}

export default HeaderModaComment;
